import { render, staticRenderFns } from "./dedicatedDietSupplement.vue?vue&type=template&id=c43384e8"
import script from "./dedicatedDietSupplement.vue?vue&type=script&lang=js"
export * from "./dedicatedDietSupplement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports